import type { OnInit } from '@angular/core';
import { Component, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import type { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import {
    BaseMultiSelectFormFieldComponent
} from '@shared/form-fields/multi-select/base-multi-select-form-field.component';
import type { AppSelectOption } from '@shared/form-fields/options/select-option';
import { ApiParams } from '@shared/http/api-params';
import type { User } from '../user';
import { UserFetcher } from '../user.fetcher';

@Component({
    selector: 'app-user-multi-select',
    styleUrls: ['./user-multi-select.component.scss'],
    templateUrl: '../../../form-fields/multi-select/multi-select-form-field.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => UserMultiSelectComponent), multi: true }],
})
export class UserMultiSelectComponent extends BaseMultiSelectFormFieldComponent<User> implements OnInit {
    @Input() maxSelectedShowing = 1;
    @Input() params: ApiParams = {};
    @Input() disableOptions: string[];

    constructor(element: ElementRef, renderer: Renderer2, private fetcher: UserFetcher) {
        super(element, renderer);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.fetcher
            .all({
                ...this.params,
                order_by: 'name',
                direction: 'asc',
            })
            .subscribe(response => {
                this.apiOptions = [
                    ...response.data.map(user => ({
                        label: user.name,
                        value: user,
                        description: user.email,
                    })),
                ];
            });
    }

    onSelectionChange($event: MatSelectChange) {
        super.onSelectionChange($event);

        const value: AppSelectOption<User>[] = $event.value;

        if (value.length === 0) {
            this.selectedOptions = [...this.options];
        }
    }

    isOptionDisabled(option: AppSelectOption<User>): boolean {
        if (this.disableOptions) {
            return this.disableOptions.includes(option.value.id);
        }

        return super.isOptionDisabled(option);
    }

    get selectedOptionsLabel(): string {
        if (this.allOptionsSelected) {
            return 'All Users';
        }

        return super.selectedOptionsLabel;
    }

    get triggerLabel(): string {
        if (this.allOptionsSelected) {
            return `<span class="badge badge-small badge-outline">All Users Selected</span>`;
        }

        return null;
    }
}
